import "bootstrap/dist/css/bootstrap.min.css";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { firebase } from "./../firebase";
import { Row, Col } from "reactstrap";
import "../../css/LoginModal.css";
import "../../css/toastify.css";
import "react-toastify/dist/ReactToastify.css";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { ToastContainer, toast, Flip } from "react-toastify";
import { toastConfig } from "../Custom/ToastConfig";
import CustomSpinner from "../Custom/spinner";

class ResetPassword extends Component {
  constructor(props, { match }) {
    super(props, { match });
    this.state = {
      email: "",
      otp: "",
      newPassword: "",
      loading: false,
      step: "email", // 'email' or 'otp'
      resendCooldown: 0,
      error: "",
      banner: { visible: false, message: '', type: 'success' },
    };
    this.resendTimer = null;
  }

  handleInputChanged = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  showBanner = (message, type = 'info', duration = 3000) => {
    this.setState({ banner: { visible: true, message, type } });
    setTimeout(() => {
      this.setState({ banner: { visible: false, message: '', type: 'info' } });
    }, duration);
  };

  startResendCooldown = () => {
    if (this.resendTimer) clearInterval(this.resendTimer);
    this.setState({ resendCooldown: 60 });
    this.resendTimer = setInterval(() => {
      this.setState(prev => {
        if (prev.resendCooldown <= 1) {
          clearInterval(this.resendTimer);
          this.resendTimer = null;
          return { resendCooldown: 0 };
        }
        return { resendCooldown: prev.resendCooldown - 1 };
      });
    }, 1000);
  };
  handleReset = () => {
    this.setState({
      email: "",
      otp: "",
      newPassword: "",
      step: "email",
      resendCooldown: 0,
      error: "",
    });
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
      this.resendTimer = null;
    }
  };

  handleRequestOtp = async () => {
    const { email } = this.state;
    if (!email.trim()) {
      this.setState({ error: 'Email is required' });
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      this.setState({ error: 'Invalid email format' });
      return;
    }
    this.setState({ loading: true, error: '' });
    try {
      const response = await fetch('https://d1dgpoid6t01jm.cloudfront.net/user/request-password-reset', {
        method: "POST",
        headers: {
          "Content-Type": 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Accept-Encoding": "gzip"
        },
        body: JSON.stringify({ email: email.trim() })
      });
      const responseData = await response.json();
      if (responseData.status === "success" || responseData.success) {
        this.setState({ step: 'otp', loading: false, error: '' });
        this.showBanner(responseData.message || 'OTP sent to your email', 'success');
        this.startResendCooldown();
      } else if (responseData.errors) {
        const errorData = responseData.errors;
        Object.keys(errorData).forEach((field) => {
          errorData[field].forEach((message) => {
            toast(`${field.charAt(0).toUpperCase() + field.slice(1)}: ${message}`, toastConfig);
          });
        });
        this.setState({ loading: false });
      } else {
        this.showBanner(responseData.message || 'Something went wrong', 'error');
        this.setState({ loading: false });
      }
    } catch (err) {
      this.showBanner(err.message || 'Server communication error', 'error');
      this.setState({ loading: false });
    }
  };


  handleResendOtp = async () => {
    if (this.state.resendCooldown > 0) return;
    const { email } = this.state;
    if (!email.trim()) {
      this.setState({ error: 'Email is required' });
      return;
    }
    this.setState({ loading: true, error: '' });
    try {
      const response = await fetch('https://d1dgpoid6t01jm.cloudfront.net/user/request-password-reset', {
        method: "POST",
        headers: {
          "Content-Type": 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Accept-Encoding": "gzip"
        },
        body: JSON.stringify({ email: email.trim() })
      });
      const responseData = await response.json();
      if (responseData.status === "success" || responseData.success) {
        this.showBanner(responseData.message || 'OTP resent to your email', 'success');
        this.startResendCooldown();
      } else {
        this.showBanner(responseData.message || 'Something went wrong', 'error');
      }
      this.setState({ loading: false });
    } catch (err) {
      this.showBanner(err.message || 'Server communication error', 'error');
      this.setState({ loading: false });
    }
  };


  handleResetPassword = async () => {
    const { email, otp, newPassword } = this.state;
    if (!email.trim() || !otp.trim() || !newPassword.trim()) {
      this.setState({ error: 'Email, OTP, and new password are required' });
      return;
    }
    this.setState({ loading: true, error: '' });
    try {
      const response = await fetch(
        "https://d1dgpoid6t01jm.cloudfront.net/user/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Accept-Encoding": "gzip",
          },
          body: JSON.stringify({
            email: email.trim(),
            otp: otp.trim(),
            newPassword: newPassword,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.status === "success" || responseData.success) {
        this.showBanner(responseData.message || 'Password reset successfully', 'success', 1200);
        setTimeout(() => {
          this.setState({ loading: false });
          if (this.props.onResetSuccess) {
            this.props.onResetSuccess();
          } else if (this.props.history) {
            this.props.history.push('/login');
          } else {
            window.location.href = '/login';
          }
        }, 1200);
      } else if (responseData.errors) {
        const errorData = responseData.errors;
        Object.keys(errorData).forEach((field) => {
          errorData[field].forEach((message) => {
            toast(`${field.charAt(0).toUpperCase() + field.slice(1)}: ${message}`, toastConfig);
          });
        });
        this.setState({ loading: false });
      } else {
        this.showBanner(responseData.message || 'Password reset failed', 'error');
        this.setState({ loading: false });
      }
    } catch (err) {
      this.showBanner(err.message || 'Server communication error', 'error');
      this.setState({ loading: false });
    }
  };
  render() {
    const { step, email, otp, newPassword, resendCooldown, error, banner } = this.state;
    return (
      <div>
        <Row>
          <Col sm="12">
            <h2 style={{ color: "white", textAlign: "center" }}>
              Reset your password
            </h2>
            <div className="modalcontainer ">
              {banner.visible && (
                <div style={{ background: banner.type === 'success' ? '#4BB543' : '#FF3333', color: '#fff', padding: 10, borderRadius: 6, marginBottom: 10, textAlign: 'center' }}>{banner.message}</div>
              )}
              <ValidatorForm onSubmit={e => { e.preventDefault(); step === 'email' ? this.handleRequestOtp() : this.handleResetPassword(); }}>
                <div className="form-group">
                  <div className="inputfield">
                    <TextValidator
                      type="email"
                      className="form-control"
                      placeholder="Enter your registered email"
                      name="email"
                      value={email}
                      validators={["required", "isEmail"]}
                      errorMessages={["Valid Email is required"]}
                      onChange={this.handleInputChanged}
                      disabled={step === 'otp'}
                    />
                  </div>
                </div>
                {step === 'otp' && (
                  <>
                    <div className="form-group">
                      <div className="inputfield">
                        <TextValidator
                          type="text"
                          className="form-control"
                          placeholder="Enter OTP"
                          name="otp"
                          value={otp}
                          validators={["required"]}
                          errorMessages={["OTP is required"]}
                          onChange={this.handleInputChanged}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="inputfield">
                        <TextValidator
                          type="password"
                          className="form-control"
                          placeholder="Enter new password"
                          name="newPassword"
                          value={newPassword}
                          validators={["required"]}
                          errorMessages={["New password is required"]}
                          onChange={this.handleInputChanged}
                        />
                      </div>
                    </div>
                    <div style={{ marginBottom: 10, textAlign: 'center' }}>
                      <button
                        type="button"
                        onClick={this.handleResendOtp}
                        disabled={resendCooldown > 0}
                        style={{
                          background: 'transparent',
                          color: resendCooldown > 0 ? '#ff9800' : '#E9C589',
                          border: 'none',
                          textDecoration: 'underline',
                          cursor: resendCooldown > 0 ? 'not-allowed' : 'pointer',
                          fontWeight: 'bold',
                          fontSize: '1.15rem',
                          letterSpacing: '0.5px',
                          transition: 'color 0.2s',
                        }}
                      >
                        {Number(resendCooldown) > 0 ? (
                          <span style={{ color: '#ff9800', fontWeight: 'bold' }}>
                            Resend OTP in{' '}
                            <span style={{ color: '#ff9800', fontWeight: 'bold', fontFamily: 'monospace, "Courier New", Courier, Arial, sans-serif' }}>{Number(resendCooldown)}</span>
                            <span style={{ color: '#ff9800', fontWeight: 'bold' }}>s</span>
                          </span>
                        ) : (
                          'Resend OTP'
                        )}
                      </button>
                    </div>
                  </>
                )}
                {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
                <center className="bottom">
                  {step === 'email' ? (
                    <button type="submit" style={{ background: "black", color: "#E9C589" }} className="servie-link button-slanted nav-link">
                      Request OTP
                    </button>
                  ) : (
                    <button type="submit" style={{ background: "black", color: "#E9C589" }} className="servie-link button-slanted nav-link">
                      Reset Password
                    </button>
                  )}
                </center>
              </ValidatorForm>
            </div>
          </Col>
        </Row>
        <ToastContainer transition={Flip} />
        {this.state.loading ? (
          <CustomSpinner spinnerVal={true} />
        ) : null}
      </div>
    );
  }
}

export default withRouter((ResetPassword));
